<template>
    <v-menu v-model="show" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template #activator="{ on, attrs }">
            <v-text-field
                dense
                outlined
                :class="inputClass"
                :clearable="!readOnly && clearable"
                :value="focus ? value : parseTime(value)"
                :label="label"
                :placeholder="placeholder"
                :required="required"
                v-bind="{ ...attrs, ...$attrs }"
                @click:append="show = true"
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur"
                @keydown.tab="onTab"
                v-on="readOnly ? null : on"
            >
                <template #append>
                    <v-btn icon plain x-small tabindex="-1" @click="show = true">
                        <KpIcon :icon-cls="appendIcon" size="16" color="grey" />
                    </v-btn>
                </template>
            </v-text-field>
        </template>
        <div class="d-flex flex-column">
            <v-time-picker
                v-if="show"
                format="24hr"
                scrollable
                :value="parseTime(value)"
                :use-seconds="useSeconds"
                @input="valueChanged"
                @click:minute="onMinuteClick"
            />
            <ActionBtn @mousedown.prevent.stop="onNowButtonClick">{{ $t('now') }}</ActionBtn>
        </div>
    </v-menu>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'TimeTextfield',

    props: {
        readOnly: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
        useSeconds: {
            type: Boolean,
            default: false,
        },
        inputClass: {
            type: [String, Object],
            default: null,
        },
        appendIcon: {
            type: String,
            default: 'ic ic-16 ic-hourglass ic-col-grey',
        },
        clearable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            focus: false,
            show: false,
        };
    },
    methods: {
        parseTime(input) {
            if (input) {
                const matches = input?.match(/([0-9]{1,2}):?(([0-9]{1,2}):?([0-9]{1,2})?)?.*/);
                let hours = '00';
                if (matches.length >= 1 && matches[1]) {
                    hours = matches[1];
                }
                let minutes = '00';
                if (matches.length >= 3 && matches[3]) {
                    minutes = matches[3];
                }
                input = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
                if (this.useSeconds) {
                    let seconds = '00';
                    if (matches.length >= 4 && matches[4]) {
                        seconds = matches[4];
                    }
                    input += `:${seconds.padStart(2, '0')}`;
                }
                return input;
            } else {
                return null;
            }
        },

        onInput(value) {
            this.valueChanged(value);
        },

        valueChanged(value) {
            this.$emit('input', value);
        },

        onFocus(event) {
            this.focus = true;
        },

        onBlur(event) {
            // This is intentional: this allows to get other events handled, before
            // the blur occurs, e.g. the "now"-btn handler:
            setTimeout(() => {
                this.focus = false;
                this.valueChanged(this.parseTime(this.value));
            }, 50);
        },

        onMinuteClick() {
            this.show = false;
        },

        onNowButtonClick() {
            let format = 'HH:mm';
            if (this.useSeconds) {
                format += ':ss';
            }
            this.valueChanged(dayjs().formatIf(format));
            this.show = false;
        },
        onTab() {
            this.show = false;
        },
    },
};
</script>
